import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import CallIcon from '@mui/icons-material/Call';
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'

import { whiteColor } from '../../../utils/colors';

import {
    CloseOutlined as NoneIcon,
    TitleOutlined as TextIcon,
    ImageOutlined as ImageIcon,
    VideocamOutlined as VideoIcon,
    DescriptionOutlined as DocumentIcon,
    GifBoxOutlined as GifBoxIcon,
} from '@mui/icons-material';

import globalStyles from '../../../assets/styles/global.module.scss';
import styles from '../../../assets/styles/componentStyles/templatemessages.module.scss';
import messageGuidelinesStyles from '../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss';

import { BTN_SUB_TYPE_NAMES, BTN_TYPE_NAMES, checkErrorFromWord, getTemplateCategoryId, INTERACTIVE_TEMPLATE_TYPE, TEMPLATE_CATEGORY, TEMPLATE_TYPES, isCarouselTemplate, getValidationsFromInteractiveType, isTemplateCategoryMarketing, isCatalogTemplate, isInteractiveCatalogTemplate, isInteractiveTypeMessageRequestContactInfo, hasShareContactInfoButton } from '../channels/global/whatsapp/templates/utils';
import { getInitialWhatsappTemplateObject } from '../channels/global/whatsapp/whatsAppIntegrationConstant';
import { formatString } from '../../../utils/constants';
import validator from 'validator';

export const getButtonsIconByName = (name) => {
    switch (name?.toLowerCase()) {
        case BTN_SUB_TYPE_NAMES['CUSTOM']?.toLowerCase():
            return <ReplyIcon className={globalStyles.displayFlexStyle} />;
        case BTN_SUB_TYPE_NAMES['VISIT_WEBSITE']?.toLowerCase():
            return <OpenInNewOutlinedIcon className={globalStyles.displayFlexStyle} />;
        case BTN_SUB_TYPE_NAMES['CALL_PHONE_NUMBER']?.toLowerCase():
            return <CallIcon className={globalStyles.displayFlexStyle} />;
        case BTN_SUB_TYPE_NAMES['COMPLETE_FLOW']?.toLowerCase():
            return <ListIcon className={globalStyles.displayFlexStyle} />;
        case BTN_SUB_TYPE_NAMES['COPY_OFFER_CODE']?.toLowerCase():
        case BTN_SUB_TYPE_NAMES['COPY_CODE']?.toLowerCase():
            return <ContentCopyIcon className={globalStyles.displayFlexStyle} />;
        case BTN_SUB_TYPE_NAMES['OPEN_FORM']?.toLowerCase():
            return <AssignmentIcon className={globalStyles.displayFlexStyle} />;
        case BTN_SUB_TYPE_NAMES['SHARE_CONTACT_INFO']?.toLowerCase():
            return <ContactsOutlinedIcon className={globalStyles.displayFlexStyle} />;
        default:
            return "";
    }
}

export const subButtonTypeIconMap = {
    [BTN_SUB_TYPE_NAMES['VISIT_WEBSITE']?.toLowerCase()]: 
        <OpenInNewOutlinedIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['CALL_PHONE_NUMBER']?.toLowerCase()]: 
        <CallIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['CUSTOM']?.toLowerCase()]: 
        <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['MARKETING_OPT_OUT']?.toLowerCase()]: 
        <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['OPEN_FORM']?.toLowerCase()]: 
        <AssignmentIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['COPY_CODE']?.toLowerCase()]: 
        <ContentCopyIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['COPY_OFFER_CODE']?.toLowerCase()]: 
        <ContentCopyIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['COMPLETE_FLOW']?.toLowerCase()]: 
        <ListIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    [BTN_SUB_TYPE_NAMES['SHARE_CONTACT_INFO']?.toLowerCase()]: 
        <ContactsOutlinedIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    "default": 
        <ListIcon style={{ display: "flex" }} className={styles.previewSubButton} />,
    null: "",
}

export const getButtonSubTypeNameById = (buttonSubTypeId, whatsappTemplateButtonGenericData) => {

    for (const btn of whatsappTemplateButtonGenericData || []) {

        const subButton = btn?.whatsapp_template_button_sub_type_data?.find(
            (subButtonItem) => Number(subButtonItem?.whatsapp_template_button_sub_type_id) === Number(buttonSubTypeId)
        );

        if (subButton) {
            return subButton.whatsapp_template_button_sub_type_name;
        }
    }

    return "";
};

export const getSubButtonIcon = (buttonSubTypeId, whatsappTemplateButtonGenericData) => {

    const subTypeName = getButtonSubTypeNameById(buttonSubTypeId, whatsappTemplateButtonGenericData)?.toLowerCase();
    
    return subButtonTypeIconMap[subTypeName];
};

export const getSubButtonText = (subBtnData) => {
    let fieldVal = subBtnData?.whatsapp_template_button_sub_type_field_data?.filter((field) => field?.field_name === "Button Text")[0]

    switch (fieldVal?.field_static_value_flag) {
        case true:
            return fieldVal?.field_static_value
        case false:
            return fieldVal?.whatsapp_template_button_sub_type_field_value
        default:
            return ""
    }
};

const getNormalizedButtonText = (buttonData) => (getSubButtonText(buttonData) ?? "").trim().toLowerCase();

export const DUPLICATE_BUTTON_TEXT_ERROR = "Please enter unique button text";

export const hasDuplicateButtonText = (templateButtons = [], buttonIndex, dataIndex) => {
    
    const currentText = (buttonIndex !== undefined && dataIndex !== undefined)
        ? getNormalizedButtonText(templateButtons?.[buttonIndex]?.whatsapp_template_button_data?.[dataIndex])
        : null;

    if (buttonIndex !== undefined && dataIndex !== undefined && !currentText) {
        return false;
    }

    const buttonTexts = (templateButtons ?? [])
        .flatMap((buttonGroup) => buttonGroup?.whatsapp_template_button_data ?? [])
        .map(getNormalizedButtonText)
        .filter(Boolean);

    if (currentText === null) {
        return new Set(buttonTexts).size !== buttonTexts.length;
    }

    return buttonTexts.filter((text) => text === currentText).length > 1;
};

export const getSubButtonDescription = (subBtnData) => {
    let fieldVal = subBtnData?.whatsapp_template_button_sub_type_field_data?.filter((field) => field?.field_name?.toLowerCase() === "button description")[0]
    return fieldVal?.whatsapp_template_button_sub_type_field_value || "";
};

export const isFlowButton = (buttonTypeId, whatsappTemplateButtonGenericData) => {
    const flowButton = whatsappTemplateButtonGenericData?.find((btn) => btn.whatsapp_template_button_type_id === buttonTypeId);
    if (flowButton) {
        return flowButton?.whatsapp_template_button_type_name?.toLowerCase() === "flow";
    }
    return false;
};

export const checkFlagError = (type, createTemplatePayload) => {
    let wordForBody = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_value;
    let wordForHeader = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || "";
    if (type.toLowerCase() === "body") {
        return checkErrorFromWord(wordForBody, createTemplatePayload?.flag_named_parameter);
    } else if (type.toLowerCase() === "header") {
        return checkErrorFromWord(wordForHeader, createTemplatePayload?.flag_named_parameter);
    } else if (type.toLowerCase() === "both") {
        if (wordForHeader) return checkErrorFromWord(wordForBody, createTemplatePayload?.flag_named_parameter) || checkErrorFromWord(wordForHeader, createTemplatePayload?.flag_named_parameter);
        return checkErrorFromWord(wordForBody, createTemplatePayload?.flag_named_parameter);
    }
};

export const checkDisableAddVarButton = (createTemplatePayload) => {
    const fields = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data;
    return fields?.length >= 1;
};

// Create Button Functions
export const buildButtonField = (fieldConfig) => ({
    whatsapp_template_button_field_data_id: null,
    whatsapp_template_button_sub_type_field_id: fieldConfig.field_id,
    whatsapp_template_button_sub_type_field_value: fieldConfig.field_value ?? (fieldConfig.field_name?.toLowerCase() === "payload" ? [] : ""),
    whatsapp_template_button_sub_type_field_option_id: fieldConfig.field_option_id ?? 0,
    whatsapp_template_button_field_data_flag_deleted: false,
    field_name: fieldConfig.field_name,
    field_type: fieldConfig.field_type,
    field_placeholder: fieldConfig.field_placeholder,
    field_static_value_flag: fieldConfig.field_static_value_flag,
    field_static_value: fieldConfig.field_static_value,
    field_option_flag: fieldConfig.field_option_flag ?? false,
    field_meta_key_name: "",
    field_option_value: null,
    field_character_limit: fieldConfig.field_character_limit ?? null,
    field_option_data: fieldConfig.field_option_data ?? [],
    whatsapp_template_button_type_name: fieldConfig.button_type_name,
    whatsapp_template_button_sub_type_name: fieldConfig.button_sub_type_name,
    whatsapp_template_button_id: fieldConfig.button_type_id,
    whatsapp_template_button_index: fieldConfig.button_index,
    whatsapp_template_button_field_data_variable: [],
});

export const buildCreateFromScratchButton = (typeId, buttonText, subTypeName = "", buttonIndex = 0, whatsappTemplateButtonGenericData = []) => {
    
    const selectedButtonType = whatsappTemplateButtonGenericData?.find(
        (btn) => btn?.whatsapp_template_button_type_id === typeId
    );

    if (!selectedButtonType) {
        return null;
    }

    const buttonSubTypes = selectedButtonType?.whatsapp_template_button_sub_type_data ?? [];
    
    const selectedButtonSubType =
        buttonSubTypes.find((subTypeItem) =>
            subTypeItem?.whatsapp_template_button_sub_type_name?.toLowerCase() === subTypeName?.toLowerCase()
        ) 
        ??
        ((subTypeName?.toLowerCase() === "url")
            ? buttonSubTypes?.find((subTypeItem) => subTypeItem?.whatsapp_template_button_sub_type_name?.toLowerCase() === "visit website")
            : null) 
        ??
        buttonSubTypes?.[0];
    
    if (!selectedButtonSubType) {
        return null;
    }

    const buttonFields = selectedButtonSubType?.whatsapp_template_button_sub_type_field_data?.map((fieldItem) => {
        
        const staticOption = fieldItem?.field_option_data?.find(
            (optionItem) => optionItem?.field_option_value?.toLowerCase() === "static"
        );
        const defaultOptionId = staticOption?.field_option_id;
        const defaultOptionValue = fieldItem?.field_option_data?.find((optionItem) => optionItem?.field_option_id === defaultOptionId)?.field_option_value;

        let fieldValue = fieldItem?.whatsapp_template_button_sub_type_field_value;
        
        if (fieldItem?.field_name?.toLowerCase() === "button text") fieldValue = buttonText;
        if (fieldItem?.field_name?.toLowerCase() === "url type") fieldValue = defaultOptionValue;
        if (fieldItem?.field_name?.toLowerCase() === "website url") fieldValue = subTypeName?.toLowerCase() === "url" ? "https://chronox.ai/" : (fieldValue ?? "");
        if (fieldItem?.field_name?.toLowerCase() === "payload") fieldValue = Array.isArray(fieldValue) ? fieldValue : [];

        return buildButtonField({
            field_id: fieldItem?.whatsapp_template_button_sub_type_field_id,
            field_name: fieldItem?.field_name,
            field_type: fieldItem?.field_type,
            field_placeholder: fieldItem?.field_placeholder,
            field_static_value_flag: fieldItem?.field_static_value_flag,
            field_static_value: fieldItem?.field_static_value,
            field_character_limit: fieldItem?.field_character_limit,
            field_option_flag: fieldItem?.field_option_flag,
            field_option_data: fieldItem?.field_option_data,
            field_option_id: defaultOptionId,
            field_value: fieldValue,
            button_type_id: typeId,
            button_type_name: selectedButtonType?.whatsapp_template_button_type_name,
            button_sub_type_name: selectedButtonSubType?.whatsapp_template_button_sub_type_name,
            button_index: buttonIndex,
        });
    });

    return {
        whatsapp_template_button_id: null,
        flag_allow_tracking: getButtonSubTypeIdByName(whatsappTemplateButtonGenericData ?? [], "Call to action", "Visit Website") === selectedButtonSubType?.whatsapp_template_button_sub_type_id ? true : false, // for visit website button make true
        whatsapp_template_button_type_id: typeId,
        whatsapp_template_button_data: [
            {
                whatsapp_template_button_data_id: null,
                whatsapp_template_button_sub_type_id: selectedButtonSubType?.whatsapp_template_button_sub_type_id,
                whatsapp_template_button_sub_type_name: selectedButtonSubType?.whatsapp_template_button_sub_type_name,
                whatsapp_template_button_sub_type_field_data: buttonFields,
            },
        ],
    };
}

// Get Button Functions
export const getButtonSubTypeIdByName = (whatsappTemplateButtonGenericData, buttonTypeName, buttonSubTypeName) => {
    const button = whatsappTemplateButtonGenericData?.find(
        (btn) => btn?.whatsapp_template_button_type_name?.toLowerCase() === buttonTypeName?.toLowerCase()
    );
    const buttonSubType = button?.whatsapp_template_button_sub_type_data?.find(
        (btn) => btn?.whatsapp_template_button_sub_type_name?.toLowerCase() === buttonSubTypeName?.toLowerCase()
    );
    if (buttonSubType) {
        return buttonSubType?.whatsapp_template_button_sub_type_id;
    }
    return null;
}

export const getButtonTypeIdByName = (whatsappTemplateButtonGenericData, buttonTypeName) => {
    const buttonType = whatsappTemplateButtonGenericData?.find(
        (btn) => btn?.whatsapp_template_button_type_name?.toLowerCase() === buttonTypeName?.toLowerCase()
    );
    if (buttonType) {
        return buttonType?.whatsapp_template_button_type_id;
    }
    return null;
}

export const getHeaderTypeIdByName = (whatsappTemplateHeaderTypes = [], headerTypeName) => {
    const headerType = whatsappTemplateHeaderTypes?.find(
        (type) => type?.whatsapp_template_header_type_name?.toLowerCase() === headerTypeName?.toLowerCase()
    );
    if (headerType) {
        return headerType?.whatsapp_template_header_type_id;
    }
    return null;
}

// Basic Template
export const createBasicTemplateFromScratch = (templateLibraryCategoryList = [], whatsappTemplateButtonGenericData = []) => {

    const callToActionButtonTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData ?? [], "Call to action");

    return {
        ...getInitialWhatsappTemplateObject(null, true, templateLibraryCategoryList),
        whatsapp_template_data: {
            ...getInitialWhatsappTemplateObject(null, true, templateLibraryCategoryList).whatsapp_template_data,
            whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateLibraryCategoryList ?? []),
            whatsapp_language_id: 15,
            whatsapp_template_display_name: "Untitled Template",

            whatsapp_template_body: {
                ...getInitialWhatsappTemplateObject(null, true, templateLibraryCategoryList).whatsapp_template_data.whatsapp_template_body,
                whatsapp_template_body_value: 'Hi {{name}},\n\nThis is a sample message.\nCustomise the content using text and variables.',
                whatsapp_template_body_variable_data: [
                    { 
                        whatsapp_template_dynamic_variable_key: '{{name}}', 
                        whatsapp_template_dynamic_variable_sample_value: 'John' 
                    }
                ],
            },  

            whatsapp_template_footer: {
                ...getInitialWhatsappTemplateObject(null, true, templateLibraryCategoryList).whatsapp_template_data.whatsapp_template_footer,
                whatsapp_template_footer_value: '',
            },

            whatsapp_template_button: [
                buildCreateFromScratchButton(callToActionButtonTypeId, "Visit Website", "url", 1, whatsappTemplateButtonGenericData ?? []),
            ].filter((button) => Boolean(button)) ?? [],
        },
    }
};

// Catalog Template
export const createCatalogTemplateFromScratch = (templateLibraryCategoryList = [], whatsappTemplateButtonGenericData = [], whatsappTemplateTypes = []) => {
    const viewCatalogBtnTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData ?? [], BTN_TYPE_NAMES['CATALOG']);
    const scratchPreview = createBasicTemplateFromScratch(templateLibraryCategoryList, whatsappTemplateButtonGenericData);

    return {
        ...scratchPreview,
        whatsapp_template_type_id: getTemplateTypeIdByName(whatsappTemplateTypes ?? [], TEMPLATE_TYPES['CATALOG']),
        whatsapp_template_data: {
            ...scratchPreview?.whatsapp_template_data,
            whatsapp_template_body: {
                ...scratchPreview?.whatsapp_template_data?.whatsapp_template_body,
                whatsapp_template_body_value: 'This is a sample catalog message.\nCustomise the content using text and variables.',
                whatsapp_template_body_variable_data: [],
            },  
            whatsapp_template_button: [
                buildCreateFromScratchButton(viewCatalogBtnTypeId, "View catalog", BTN_SUB_TYPE_NAMES['VIEW_CATALOG'], 1, whatsappTemplateButtonGenericData ?? []),
            ].filter((button) => Boolean(button)) ?? [],
        },
    };
};

// Authentication Template
export const createAuthenticationTemplateFromScratch = (isTemplateLibrary = false, templateLibraryCategoryList = [], whatsappTemplateButtonGenericData = []) => {

    const copyCodeButtonTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData ?? [], "Copy code");
    
    return {
        ...getInitialWhatsappTemplateObject(null, isTemplateLibrary, templateLibraryCategoryList ?? []),
        flag_named_parameter: false,
        whatsapp_template_data: {
            ...getInitialWhatsappTemplateObject(null, isTemplateLibrary, templateLibraryCategoryList ?? []).whatsapp_template_data,
            whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.AUTHENTICATION, templateLibraryCategoryList ?? []),
            whatsapp_language_id: 15,

            whatsapp_template_body: {
                ...getInitialWhatsappTemplateObject(null, isTemplateLibrary, templateLibraryCategoryList ?? []).whatsapp_template_data.whatsapp_template_body,
                whatsapp_template_body_value: "*{{1}}* is your verification code.",
                whatsapp_template_body_variable_data: [
                { 
                    whatsapp_template_dynamic_variable_key: '{{1}}', 
                    whatsapp_template_dynamic_variable_sample_value: '123456' 
                }
                ],
            },

            whatsapp_template_footer: {
                ...getInitialWhatsappTemplateObject(null, isTemplateLibrary, templateLibraryCategoryList ?? []).whatsapp_template_data.whatsapp_template_footer,
                whatsapp_template_footer_value: "Expires in 10 minutes.",
            },
            
            whatsapp_template_button: [
                buildCreateFromScratchButton(copyCodeButtonTypeId, 'Copy Code', BTN_SUB_TYPE_NAMES['COPY_CODE'], 1, whatsappTemplateButtonGenericData ?? []),
            ],

            whatsapp_template_code_expiration_minutes: 10,
            whatsapp_template_security_recommendation: false,
        },
    }
};

// Carousel Template
export const createCarouselTemplateFromScratch = (templateLibraryCategoryList = [], whatsappTemplateButtonGenericData = [], whatsappTemplateTypes = [], whatsappTemplateHeaderTypes = []) => {
    
    const defaultCarouselHeaderTypeName = "image";

    return {
        ...getInitialWhatsappTemplateObject(null, true, templateLibraryCategoryList ?? []),
        whatsapp_template_type_id: getTemplateTypeIdByName(whatsappTemplateTypes ?? [], TEMPLATE_TYPES['CAROUSEL']),
        
        whatsapp_template_data: {
            ...getInitialWhatsappTemplateObject(null, true, templateLibraryCategoryList).whatsapp_template_data,
            
            whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateLibraryCategoryList ?? []),
            whatsapp_language_id: 15,
            whatsapp_template_display_name: "Untitled Template",

            whatsapp_template_button: [],

            whatsapp_template_carousel: {
                whatsapp_template_carousel_header: "This is a sample message body text.",
                whatsapp_template_carousel_header_dynamic_variable: [],
                whatsapp_template_carousel_card: [
                    buildDefaultCarouselCard(whatsappTemplateButtonGenericData, whatsappTemplateHeaderTypes, defaultCarouselHeaderTypeName),
                    buildDefaultCarouselCard(whatsappTemplateButtonGenericData, whatsappTemplateHeaderTypes, defaultCarouselHeaderTypeName),
                ],
            },
        },
    }
}

const buildDefaultCarouselCard = (whatsappTemplateButtonGenericData = [], whatsappTemplateHeaderTypes = [], defaultCarouselHeaderTypeName = "image") => {
    
    const defaultCarouselHeaderTypeId = getHeaderTypeIdByName(whatsappTemplateHeaderTypes ?? [], defaultCarouselHeaderTypeName);
    const callToActionButtonTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData ?? [], "Call to action");
    const defaultCardButton = buildCreateFromScratchButton(callToActionButtonTypeId, "Visit Website", "url", 1, whatsappTemplateButtonGenericData ?? []);

    return {
        whatsapp_template_header: {
            whatsapp_template_header_type_id: defaultCarouselHeaderTypeId ?? 1,
            whatsapp_template_header_type_name: defaultCarouselHeaderTypeName,
            whatsapp_template_header_data: [{
                whatsapp_template_header_data_value: "",
                whatsapp_template_header_data_id: 0,
                whatsapp_template_header_data_google_storage_id: 0,
                whatsapp_template_header_variable_data: [],
            }],
        },
        whatsapp_template_body: {
            whatsapp_template_body_value: "This is a sample carousel card message.",
            whatsapp_template_body_description: "",
            whatsapp_template_body_variable_data: [],
        },
        whatsapp_template_button: [defaultCardButton]?.filter((button) => Boolean(button)),
        whatsapp_template_footer: {
            whatsapp_template_footer_value: "",
            whatsapp_template_footer_id: null,
        },
    };
};

// Call Permission Request Template
export const createCallPermissionRequestTemplateFromScratch = (templateLibraryCategoryList = [], whatsappTemplateButtonGenericData = [], whatsappTemplateTypes = []) => {

    const scratchPreview = createBasicTemplateFromScratch(templateLibraryCategoryList, whatsappTemplateButtonGenericData);

    return {
        ...scratchPreview,
        whatsapp_template_type_id: getTemplateTypeIdByName(whatsappTemplateTypes ?? [], TEMPLATE_TYPES['CALL_PERMISSION_REQUEST']),
        whatsapp_template_data: {
            ...scratchPreview?.whatsapp_template_data,
            whatsapp_template_body: {
                ...scratchPreview?.whatsapp_template_data?.whatsapp_template_body,
                whatsapp_template_body_value: 'We would like to call you to help support your query. Please grant us permission to call you.',
                whatsapp_template_body_variable_data: [],
            },  
            whatsapp_template_button: [],
        },
    };
}

// Draft Template
export const normalizeTemplatePayloadForDraft = (payload, whatsappTemplateTypes = []) => {
    if (!payload) return payload;

    const isCarousel = isCarouselTemplate(whatsappTemplateTypes, payload?.whatsapp_template_type_id);

    if (!isCarousel) return payload;

    const carouselCards = payload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card;
    const carouselTypeId = payload?.whatsapp_template_type_id ?? getTemplateTypeIdByName(whatsappTemplateTypes ?? [], TEMPLATE_TYPES['CAROUSEL']);

    return {
        ...payload,
        whatsapp_template_type_id: carouselTypeId,
        whatsapp_template_data: {
            ...payload.whatsapp_template_data,
            whatsapp_template_button: [],
            whatsapp_template_header: {},
            whatsapp_template_body: {},
            whatsapp_template_footer: {},
            whatsapp_template_carousel: {
                whatsapp_template_carousel_header: payload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header ?? "",
                whatsapp_template_carousel_header_dynamic_variable: payload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header_dynamic_variable ?? [],
                whatsapp_template_carousel_card: carouselCards ?? [],
            },
        },
    };
};

// Interactive Template
const getDefaultInteractiveHeader = () => ({
    whatsapp_template_header_type_id: 0,
    whatsapp_template_header_type_name: "None",
    whatsapp_template_header_data: [
        {
            whatsapp_template_header_data_value: "",
            whatsapp_template_header_data_id: 0,
            whatsapp_template_header_data_google_storage_id: 0,
            whatsapp_template_header_variable_data: [],
        },
    ],
});

export const getClearedTemplateHeader = () => getDefaultInteractiveHeader();

export const getClearedTemplateFooter = (existingFooter = {}) => ({
    ...existingFooter,
    whatsapp_template_footer_value: "",
});

const getInteractiveScratchBodyValue = (interactiveTypeKey) => {
    switch (interactiveTypeKey) {
        case INTERACTIVE_TEMPLATE_TYPE['ORDER_DETAILS']:
            return "Your order details are ready. Please review and complete your payment.";
        case INTERACTIVE_TEMPLATE_TYPE['TEXT']:
            return "This is a sample interactive text message.";
        case INTERACTIVE_TEMPLATE_TYPE['REQUEST_CONTACT_INFO']:
            return "Hi, please share your phone number with us so we can stay in touch and assist you better.";
        default:
            return "This is a sample interactive template message.";
    }
};

const buildInteractiveScratchButtons = (interactiveTypeKey, whatsappTemplateButtonGenericData = []) => {
    
    const callToActionButtonTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData, BTN_TYPE_NAMES['CALL_TO_ACTION']);
    const quickReplyButtonTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData, BTN_TYPE_NAMES['QUICK_REPLY']);
    const flowButtonTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData, BTN_TYPE_NAMES['FLOW']);
    const viewCatalogBtnTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData, BTN_TYPE_NAMES['CATALOG']);
    const requestContactInfoButtonTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData, BTN_TYPE_NAMES['REQUEST_CONTACT_INFO']);

    switch (interactiveTypeKey) {
        case INTERACTIVE_TEMPLATE_TYPE['CATALOG_MESSAGE']:
            return [
                buildCreateFromScratchButton(viewCatalogBtnTypeId, "View catalog", BTN_SUB_TYPE_NAMES['VIEW_CATALOG'], 1, whatsappTemplateButtonGenericData),
            ].filter(Boolean);
        case INTERACTIVE_TEMPLATE_TYPE['CTA_URL']:
            return [
                buildCreateFromScratchButton(callToActionButtonTypeId, "Visit Website", "url", 1, whatsappTemplateButtonGenericData),
            ].filter(Boolean);
        case INTERACTIVE_TEMPLATE_TYPE['FLOW']:
            return [
                buildCreateFromScratchButton(flowButtonTypeId, "Open Form", BTN_SUB_TYPE_NAMES['OPEN_FORM'], 1, whatsappTemplateButtonGenericData),
            ].filter(Boolean);
        case INTERACTIVE_TEMPLATE_TYPE['LIST']:
            return [
                buildCreateFromScratchButton(quickReplyButtonTypeId, "Reply", BTN_SUB_TYPE_NAMES['CUSTOM'], 1, whatsappTemplateButtonGenericData),
            ].filter(Boolean);
        case INTERACTIVE_TEMPLATE_TYPE['REPLY_BUTTONS']:
            return [
                buildCreateFromScratchButton(quickReplyButtonTypeId, "Reply", BTN_SUB_TYPE_NAMES['CUSTOM'], 1, whatsappTemplateButtonGenericData),
            ].filter(Boolean);
        case INTERACTIVE_TEMPLATE_TYPE['REQUEST_CONTACT_INFO']:
            return [
                buildCreateFromScratchButton(requestContactInfoButtonTypeId, "Share Contact Info", BTN_SUB_TYPE_NAMES['SHARE_CONTACT_INFO'], 1, whatsappTemplateButtonGenericData),
            ].filter(Boolean);
        case INTERACTIVE_TEMPLATE_TYPE['ORDER_DETAILS']:
        case INTERACTIVE_TEMPLATE_TYPE['TEXT']:
        default:
            return [];
    }
};

export const createInteractiveTemplateFromScratch = (templateLibraryCategoryList = [], whatsappTemplateButtonGenericData = [], whatsappTemplateTypes = [], interactive_type_name) => {
    
    const initialTemplateObject = getInitialWhatsappTemplateObject(null, true, templateLibraryCategoryList ?? []);
    const interactiveTypeKey = interactive_type_name ? formatString(interactive_type_name)?.toLowerCase() : null;

    return {
        ...initialTemplateObject,
        whatsapp_template_type_id: getTemplateTypeIdByName(whatsappTemplateTypes ?? [], TEMPLATE_TYPES['BASIC']),
        whatsapp_template_data: {
            ...initialTemplateObject.whatsapp_template_data,
            whatsapp_template_category_id: 0,
            whatsapp_language_id: 0,
            whatsapp_template_display_name: "Untitled Template",
            whatsapp_template_header: getDefaultInteractiveHeader(),
            whatsapp_template_body: {
                whatsapp_template_body_value: getInteractiveScratchBodyValue(interactiveTypeKey),
                whatsapp_template_body_description: "",
                whatsapp_template_body_variable_data: [],
            },
            whatsapp_template_footer: {
                ...initialTemplateObject?.whatsapp_template_data?.whatsapp_template_footer,
                whatsapp_template_footer_value: "",
            },
            whatsapp_template_button: interactiveTypeKey ? buildInteractiveScratchButtons(interactiveTypeKey, whatsappTemplateButtonGenericData ?? []) : [],
        },
    };
};

export const headerTypeIconMap = {
    none: <NoneIcon fontSize="small" />,
    text: <TextIcon fontSize="small" />,
    image: <ImageIcon fontSize="small" />,
    video: <VideoIcon fontSize="small" />,
    document: <DocumentIcon fontSize="small" />,
    gif: <GifBoxIcon fontSize="small" />,
    location: <LocationOnOutlinedIcon fontSize="small" />,
};

export const LOCATION_HEADER_FIELDS = [
    { key: '{{latitude}}', label: 'Latitude', required: true, multiline: false, placeholder: 'Enter latitude' },
    { key: '{{longitude}}', label: 'Longitude', required: true, multiline: false, placeholder: 'Enter longitude' },
    { key: '{{name}}', label: 'Name', required: false, multiline: false, placeholder: 'Enter location name' },
    { key: '{{address}}', label: 'Address', required: false, multiline: true, placeholder: 'Enter address' },
];

export const createEmptyLocationHeaderVariables = () =>
    LOCATION_HEADER_FIELDS.map((field) => ({
        whatsapp_template_dynamic_variable_key: field.key,
        whatsapp_template_dynamic_variable_sample_value: '',
    }));

const parseCoordinateValue = (value) => {
    const trimmed = String(value ?? '').trim();
    if (trimmed === '') return null;
    const number = Number(trimmed);
    return Number.isFinite(number) ? number : NaN;
};

export const isValidLatitudeValue = (value) => {
    const number = parseCoordinateValue(value);
    if (number === null) return true;
    return Number.isFinite(number) && number >= -90 && number <= 90;
};

export const isValidLongitudeValue = (value) => {
    const number = parseCoordinateValue(value);
    if (number === null) return true;
    return Number.isFinite(number) && number >= -180 && number <= 180;
};

export const getLocationSampleValueFromVariableData = (variableData = [], variableKey) =>
    (variableData.find(
        (variable) => variable?.whatsapp_template_dynamic_variable_key?.toLowerCase() === variableKey.toLowerCase()
    )?.whatsapp_template_dynamic_variable_sample_value ?? '').trim();

export const hasInvalidLocationCoordinates = (variableData = []) => {
    const latitude = getLocationSampleValueFromVariableData(variableData, '{{latitude}}');
    const longitude = getLocationSampleValueFromVariableData(variableData, '{{longitude}}');
    return (latitude !== '' && !isValidLatitudeValue(latitude))
        || (longitude !== '' && !isValidLongitudeValue(longitude));
};

export const getLocationHeaderSampleWarning = (variableData = []) => {
    const latitude = getLocationSampleValueFromVariableData(variableData, '{{latitude}}');
    const longitude = getLocationSampleValueFromVariableData(variableData, '{{longitude}}');
    const isLatitudeMissing = latitude === '';
    const isLongitudeMissing = longitude === '';
    const isLatitudeInvalid = latitude !== '' && !isValidLatitudeValue(latitude);
    const isLongitudeInvalid = longitude !== '' && !isValidLongitudeValue(longitude);

    if (isLatitudeMissing && isLongitudeMissing) {
        return 'Add sample latitude and longitude';
    }
    if (isLatitudeMissing) {
        return `Add sample latitude ${isLongitudeInvalid ? 'and longitude must be between -180° and +180°' : ''}`;
    }
    if (isLongitudeMissing) {
        return `Add sample longitude ${isLatitudeInvalid ? 'and latitude must be between -90° and +90°' : ''}`;
    }
    if (isLatitudeInvalid && isLongitudeInvalid) {
        return 'Latitude must be between -90° and +90°, and longitude between -180° and +180°';
    }
    if (isLatitudeInvalid) {
        return 'Latitude must be between -90° and +90°';
    }
    if (isLongitudeInvalid) {
        return 'Longitude must be between -180° and +180°';
    }
    return '';
};

export const getLocationCoordinateWarning = (variableKey) => {
    const normalizedKey = variableKey?.toLowerCase() ?? "";
    if (normalizedKey === "{{latitude}}") {
        return "Latitude must be between -90° and +90°";
    }
    if (normalizedKey === "{{longitude}}") {
        return "Longitude must be between -180° and +180°";
    }
    return "";
}

export const cleanFilename = (filename) => {
    // Remove the numeric suffix before .pdf using regex
    const nameWithoutSuffix = filename?.replace(/_\d+(?=\.pdf)/, '');
    // Replace underscores with spaces
    const cleanedName = nameWithoutSuffix?.replace(/_/g, ' ');
    return cleanedName;
}

export const getTooltipTextForMessageGuidelines = (isCarousel = false) => {
    return (
        <>
            <span className={messageGuidelinesStyles.whatsappPreview__guidelinesTooltip}>
                <div className={messageGuidelinesStyles.whatsappPreview__guidelinesTooltipTitle}>
                    Message Guidelines:
                </div>

                <ol className={messageGuidelinesStyles.whatsappPreview__guidelinesTooltipList}>

                    {!isCarousel && (
                        <li className={messageGuidelinesStyles.whatsappPreview__guidelinesTooltipItem}>
                            By default, the "Type of variable" is set to "Name".
                            <br />
                            • You can change the "Type of variable" by selecting the "Name" or "Number" from the dropdown in the form.
                        </li>
                    )}

                    <li className={messageGuidelinesStyles.whatsappPreview__guidelinesTooltipItem}>
                        To add dynamic variables, use double curly braces: {`{{ }}`}
                        <br />
                        • Examples:
                        <br />
                        <ul className={messageGuidelinesStyles.whatsappPreview__guidelinesTooltipList}>
                            • {`{{name}}`} – for a named parameter
                            <br />
                            • {`{{1}}`} – for a numbered parameter
                        </ul>
                        • Variables can be added in the Header (type: Text) and in the Body.
                    </li>

                    <li className={messageGuidelinesStyles.whatsappPreview__guidelinesTooltipItem}>
                        To format text in the Body, use the following:
                        <br />
                        • *bold* or press (Ctrl + B) for bold text 
                        <br />
                        • _italic_ or press (Ctrl + I) for italic text 
                        <br />
                        • ~strikethrough~ or press (Ctrl + S) for strikethrough 
                    </li>

                </ol>
            </span>
        </>
    );
}

export const handleKeyDownForFormatting = (e, handleFormatting, type, cardIndex) => {
    if (!e.ctrlKey) return;

    switch (e.key.toLowerCase()) {
        case 'b':
            e.preventDefault();
            handleFormatting('bold', type, cardIndex);
            break;
        case 'i':
            e.preventDefault();
            handleFormatting('italic', type, cardIndex);
            break;
        case 's':
            e.preventDefault();
            handleFormatting('strikethrough', type, cardIndex);
            break;
        default:
            break;
    }
};

export const TEMPLATE_NAME_MAX_LIMIT = 100;
export const TEMPLATE_NAME_TOOLTIP_MAX_LIMIT = 30;
export const TEMPLATE_NAME_TOOLTIP_MAX_LIMIT_FOR_LAPTOP = 20;

export const TEMPLATE_NAME_MAX_CHARS_MESSAGE = `Template name cannot be more than ${TEMPLATE_NAME_MAX_LIMIT} characters.`;

export const isInvalidExportFile = (payload) => {
    return payload?.meta_integration_whatsapp_id !== null
        || payload?.whatsapp_template_id !== null
        || payload?.whatsapp_template_metadata !== null
        || payload?.quality_score !== null;
};

export const getTemplateTypeIdByName = (whatsappTemplateTypes, templateTypeName) => {
    return whatsappTemplateTypes?.find((templateType) => templateType?.name?.toLowerCase() === templateTypeName?.toLowerCase())?.whatsapp_template_type_id;
}

export const MIN_CAROUSEL_CARDS = 2;
export const MAX_CAROUSEL_CARDS = 10;
export const MAX_CAROUSEL_CARDS_BUTTONS = 2;
export const ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL = ["image", "video"];

export const ALLOWED_BTN_TYPES_FOR_CAROUSEL = [BTN_TYPE_NAMES['QUICK_REPLY'], BTN_TYPE_NAMES['CALL_TO_ACTION']];
export const ALLOWED_SUB_BTN_NAMES = [BTN_SUB_TYPE_NAMES['VISIT_WEBSITE'], BTN_SUB_TYPE_NAMES['CALL_PHONE_NUMBER'], BTN_SUB_TYPE_NAMES['CUSTOM']];

export const isAllowedCarouselBtnType = (buttonTypeName) =>
    ALLOWED_BTN_TYPES_FOR_CAROUSEL?.some((allowed) => allowed?.toLowerCase() === buttonTypeName?.toLowerCase());

export const isAllowedCarouselSubBtnName = (subBtnName) =>
    ALLOWED_SUB_BTN_NAMES?.some((allowed) => allowed?.toLowerCase() === subBtnName?.toLowerCase());

export const isTemplateCreated = (createTemplatePayload) => {
    return Boolean(createTemplatePayload?.whatsapp_template_id);
}

export const COPY_TEMPLATE_DISPLAY_NAME_PREFIX = 'Copy of ';

export const getCopyTemplateDisplayName = (displayName, templateName) => {
    const name = displayName ?? templateName ?? '';
    return name ? `${COPY_TEMPLATE_DISPLAY_NAME_PREFIX}${name}` : '';
};

export const canDeleteCard = (createTemplatePayload) => {
    return !createTemplatePayload?.whatsapp_template_id && createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.length > MIN_CAROUSEL_CARDS;
}

export const getCarouselCards = (createTemplatePayload) => {
    return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card ?? [];
}

export const getCarouselCardButtonsCount = (createTemplatePayload) => {
    return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button?.length ?? 0;
}

export const CREATED_CAROUSEL_TEMPLATE_ADD_BTN_TOOLTIP_TEXT = "New buttons cannot be added once the template has been created.";
export const CREATED_CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT = "New cards cannot be added once the template has been created.";
export const CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT = "A maximum of 10 cards can be added.";
export const CAROUSEL_TEMPLATE_ADD_BTN_TOOLTIP_TEXT = "A minimum of 1 button and a maximum of 2 buttons can be added.";

export const commonButtonStyle = {
    color: '#1B7D4E !important',
    backgroundColor: `${whiteColor} !important`,
    borderColor: 'transparent !important',
    borderRadius: '8px !important',
    margin: '3px 0px !important',
    maxWidth: '87%',
};

export const disabledNotAllowedStyle = {
    opacity: 0.5,
    cursor: "not-allowed",
};

export const isInvalidUrl = (url = "") => !validator.isURL(url, { require_protocol: true, require_tld: true });

export const isInvalidDynamicWebsiteUrl = (url = "") => {
    const trimmed = (url ?? "").trim();
    if (!trimmed) return true;
    if (isInvalidUrl(trimmed)) return true;
    if (!/\{\{\d+\}\}$/.test(trimmed)) return true;
    
    const allVariables = trimmed?.match(/\{\{\d+\}\}/g) || [];
    return allVariables?.length !== 1;
};

export const isInteractiveTemplate = (createTemplatePayload) => {
    return createTemplatePayload?.whatsapp_template_flag_interactive_message;
}

export const ALLOWED_HEADER_TYPES_FOR_CALL_PERMISSION_REQUEST = ["none", "text"];

export const disableHeaderType = (headerType, createTemplatePayload, interactiveTypeList, isAuthenticationTemplate, isCallPermissionRequestTemplate) => {
    if (createTemplatePayload?.whatsapp_template_flag_interactive_message) {
        const allowedHeaderType = getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.allowed_header_type ?? [];
        return !allowedHeaderType?.includes(headerType?.toLowerCase());
    }
    if (isAuthenticationTemplate) {
        return true;
    }
    if (isCallPermissionRequestTemplate) {
        return !ALLOWED_HEADER_TYPES_FOR_CALL_PERMISSION_REQUEST?.includes(headerType?.toLowerCase());
    }
    return false;
};

export const DEFAULT_BUTTON_TEXT_TOOLTIP = "This is default text. It cannot be edited.";

// Template name regex - allows only alphanumeric characters, spaces, and underscores
export const TEMPLATE_NAME_REGEX = /^[A-Za-z0-9_ ]*$/;

export const MAX_WHATSAPP_TEMPLATE_BODY_EMOJIS = 10;

export const countEmojisInText = (text = "") => {
    if (!text) return 0;

    const regex = /(?:\p{Regional_Indicator}{2}|\p{Extended_Pictographic}(?:\uFE0F|\u200D\p{Extended_Pictographic})*)/gu;

    return (text.match(regex) || []).length;
};

export const hasTooManyBodyEmojis = (text = '') => countEmojisInText(text) > MAX_WHATSAPP_TEMPLATE_BODY_EMOJIS;

export const hasConsecutiveNewlinesInBody = (text = '') => {
    return /\n{3,}/.test(text);
};

export const hasInvalidBodyTextFormatting = (text = '', options = {}) => {
    const { checkEmojis = true } = options;

    if (hasConsecutiveNewlinesInBody(text)) {
        return true;
    }

    if (checkEmojis && hasTooManyBodyEmojis(text)) {
        return true;
    }

    return false;
};

export const doesCreateTemplateBodyHaveInvalidFormatting = (createTemplatePayload, templateLibraryCategoryList = []) => {
    if (isInteractiveTemplate(createTemplatePayload)) {
        return false;
    }

    const bodyText = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_value ?? '';
    const isMarketing = isTemplateCategoryMarketing(
        templateLibraryCategoryList,
        createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id
    );

    return hasInvalidBodyTextFormatting(bodyText, { checkEmojis: isMarketing });
};

export const hasConsecutiveNewlinesInCarouselBody = (text = '') => {
    return /\n{2,}/.test(text);
};

export const shouldShowFooterTextField = (isAuthenticationTemplate, addExpiryTimeForCode) => {
    return !isAuthenticationTemplate || addExpiryTimeForCode;
}

export const DEFAULT_EXPIRATION_MINUTES = 10;

export const MAX_BUTTONS_COUNT = 10;

export const getMaxButtonsCount = (createTemplatePayload, interactiveTypeList = [], whatsappTemplateTypes = []) => {
    
    // Check if the template is interactive
    if (isInteractiveTemplate(createTemplatePayload)) {
        return getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.maximum_button_count ?? MAX_BUTTONS_COUNT;
    }
    
    // Check if the template is a single button template
    const isSingleButtonTemplate =
        isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)
        || hasShareContactInfoButton(createTemplatePayload);

    if (isSingleButtonTemplate) {
        return 1;
    }

    return MAX_BUTTONS_COUNT;
};

export const getButtonsCount = (createTemplatePayload) => {
    return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.length ?? 0;
}
